import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class TFPAQuoteUtilsService {

    static applyCodes_TFPA(QuoteDataDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('quoteutils_tfpa'),
            'applyCodes',
            [QuoteDataDTO],
            additionalHeaders
        );
    }

    static loadPriorLosses(QuoteDataDTO, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('quoteutils_tfpa'),
            'loadPriorLosses',
            [QuoteDataDTO],
            additionalHeaders
        );
    }
}
